export default __webpack_public_path__ + "static/media/appICon.42f27459.png";